<template>
  <v-app>
    <!-- show menu only if logged in -->
    <v-navigation-drawer
    v-if="loggedAlready && config.IS_USER_ACTIVE"
    v-model="config.SHOW_APP_DRAWER"
    app
    width="275px"
    >
    <v-toolbar dense flat>
      <v-list>
        <v-list-item >
          <img height="30" src="@/assets/img/logo/sv_full.png">
        </v-list-item>
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>
    <!-- list of menuitems -->
    <v-list rounded dense>
      <template v-for="(item, i) in items">
        <!-- menu with submenus -->
        <v-list-group
        v-if="item.children.length"
        v-model="item.model"
        :prepend-icon="item.icon"
        no-action
        >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <template v-for="(child, j) in item.children">
          <!-- submenu with sub screens -->
          <v-list-group
          v-if="child.subscreens.length"
          no-action
          sub-group
          >
          <template v-slot:activator>
            <v-list-item-content class="ml-2">
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
          v-for="(subscr, k) in child.subscreens"
          :key="k"
          :to="{path: '/' + subscr.url}"
           @click="saveTrackScreenAccess(subscr), loadRoleScreenAccessListBasedOnScreenId(subscr)"
          >
          <v-list-item-title>
            {{ subscr.text }}
          </v-list-item-title>
          <v-list-item-icon v-if="subscr.icon">
            <v-icon>{{ subscr.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>

      <!-- just submenu -->
      <v-list-item v-else @click="saveTrackScreenAccess(child), loadRoleScreenAccessListBasedOnScreenId(child)" :to="{path: '/' + child.url}">
        <v-list-item-title>
          {{ child.text }}
        </v-list-item-title>
        <v-list-item-icon v-if="child.icon">
          <v-icon>{{ child.icon }}</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </template>
  </v-list-group>

  <!-- else, just one level menu items -->
  <v-list-item v-else @click="" :to="{path: '/' + item.url}">
    <v-list-item-icon>
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        {{ item.text }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template> <!-- end of all menu items -->
</v-list>
</v-navigation-drawer>

<!-- tool/app bar -->
<v-app-bar
v-if="loggedAlready"
color="primary"
dark
fixed
app
flat
dense
>
<v-app-bar-nav-icon
v-if="config.IS_USER_ACTIVE"
@click.stop="config.SHOW_APP_DRAWER = !config.SHOW_APP_DRAWER"
></v-app-bar-nav-icon>

<v-toolbar-title>
  <span>{{ $route.meta.title }}</span>
</v-toolbar-title>

<v-spacer></v-spacer>
<v-btn icon v-if="config.IS_USER_ACTIVE">
  <v-icon>mdi-bell-outline</v-icon>
</v-btn>
<v-menu offset-y v-if="config.IS_USER_ACTIVE">
  <template v-slot:activator="{ on }">
    <v-btn icon v-on="on">
      <v-icon>mdi-account-outline</v-icon>
    </v-btn>
  </template>
  <v-list>
    <v-list-item :to="{path: '/profile'}">
      <v-list-item-title>Profile</v-list-item-title>
    </v-list-item>
    <v-list-item @click = "logout">
      <v-list-item-title>Logout</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>
</v-app-bar>
<!-- end of toolbar -->

<!-- content -->
<v-content class="white">
  <router-view></router-view>
</v-content>

<v-dialog v-model="dlgPush" max-width="400px" persistent>
  <v-card flat>
    <v-card-title class="title">
      Wait!
    </v-card-title>
    <v-card-text  class="pt-0">
      <div class="subheading">You are not subscribed to push notification yet.</div>
      <div class="mt-3">
        Choose the option "allow" when you prompted next and start receiving important alerts from MyHome.
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pt-1">
      <v-spacer></v-spacer>
      <v-btn flat @click.native="dlgPush=false">Remind Me Later</v-btn>
      <v-btn flat @click.native="reqBrowserPromptForPush()" color="accent">Proceed</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

</v-app>
</template>

<script>
import config from '@/config/app-cfg'
import { isLoggedIn, logout } from '@/utils/auth'

export default {
  props: {
    source: String
  },
  data () {
    return {
      items: [],
      loggedAlready: null,
      config: config,
      userRole: '',
      dlgPush: false
    }
  },
  mounted () {
    // get current dir of app
    var curPath = require('path')
    config.APP_DIR = curPath.dirname(require.main.filename) + '/../'
    if (isLoggedIn()) {
      // load user details
      var qry = {
        params: {
          user_id: config.SV_USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getUserByID/', qry)
      .then(response => {
        if (response.data.length > 0) {
          config.VENDOR_ID = response.data[0].vendor_id
          config.VENDOR_NAME = response.data[0].vendor_name
          config.USER_NAME = response.data[0].user_name
          config.USER_DISPLAY_NAME = response.data[0].emp_name
          config.EMP_ID = response.data[0].emp_id
          config.ROLE_ID = response.data[0].role_id
          config.ROLE_NAME = response.data[0].role_name
          config.IS_ADMIN = response.data[0].role_name === 'Administrator'
          config.IS_USER_ACTIVE = response.data[0].is_active === 1
          config.AVATAR_URL = response.data[0].avatar_url
          config.PROJ_LIST = response.data[0].proj_id_list && response.data[0].proj_id_list.split(',')
          config.DASHBOARD_SCREEN_URLS = response.data[0].dashboard_screen_urls && response.data[0].dashboard_screen_urls.toLowerCase().split(',')
          config.DASHBOARD_SCREEN_NAMES = response.data[0].dashboard_screen_names && response.data[0].dashboard_screen_names.split(',')
          this.loadMenu()
          this.$router.push('/dashboard/')
        } else {
          logout()
        }
      })
      .catch(err => {
        alert(err.response.data)
        return
      })
    } else {
      // show welcome page
      this.$router.push('/')
    }
  },
  methods: {
    logout () {
      return logout()
    },
    loadMenu () {
      // load menu items from db
      // admin overrides other roles
      this.axios.get(config.API_URL + '/getMenuByRoleId/' + config.ROLE_ID)
      .then(response => {
        this.items = response.data.filter(rec => rec.screen_type !== 'ms') // all menues except menuless screens

        // create routes as well
        var curItem, curChild, curSubScr
        var rtArray = []
        var tmpComp
        for (var i = 0; i < response.data.length; i++) {
          curItem = response.data[i]
          // menu items
          if (!curItem.children.length) {
            const rtCompNm = curItem.url.charAt(0).toUpperCase() + curItem.url.slice(1)
            tmpComp = () => import('@/components/' + rtCompNm)
            rtArray.push({
              name: rtCompNm,
              path: '/' + curItem.url,
              component: tmpComp,
              meta: { title: curItem.text }
            })
            rtArray.push({
              name: rtCompNm + ' ', // added a space just to get different name
              path: '/' + curItem.url + '/:action',
              component: tmpComp,
              meta: { title: curItem.text },
              props: true
            })
          } else {
            // sub menu items
            for (var j = 0; j < curItem.children.length; j++) {
              curChild = curItem.children[j]
              if (!curChild.subscreens.length) {
                const rtCompNm = curChild.url.charAt(0).toUpperCase() + curChild.url.slice(1)
                tmpComp = () => import('@/components/' + rtCompNm)
                rtArray.push({
                  name: rtCompNm,
                  path: '/' + curChild.url,
                  component: tmpComp,
                  meta: { title: curChild.text }
                })
                rtArray.push({
                  name: rtCompNm + ' ',
                  path: '/' + curChild.url + '/:action',
                  component: tmpComp,
                  meta: { title: curChild.text },
                  props: true
                })
              } else { // sub menus with another level sub screens
                for (var k = 0; k < curChild.subscreens.length; k++) {
                  curSubScr = curChild.subscreens[k]
                  const rtCompNm = curSubScr.url.charAt(0).toUpperCase() + curSubScr.url.slice(1)
                  tmpComp = () => import('@/components/' + rtCompNm)
                  rtArray.push({
                    name: rtCompNm,
                    path: '/' + curSubScr.url,
                    component: tmpComp,
                    meta: { title: curSubScr.text }
                  })
                  rtArray.push({
                    name: rtCompNm + ' ',
                    path: '/' + curSubScr.url + '/:action',
                    component: tmpComp,
                    meta: { title: curSubScr.text },
                    props: true
                  })
                } // each subscr
              } // subscr
            } // each submenu
          } // submenu
        } // each menu
        this.$router.addRoutes(rtArray)

        // set flag to show menu
        this.loggedAlready = true

        this.$router.push('/dashboard/')

        // prompt for push subscription if needed as user might be visiting this app first time
        this.checkForPushSubsciption()
        .then(sub => {
          if (sub) {
            this.updateSubscriptionOnServer(sub)
          } else {
            // show the app specific dialog for push subscription
            this.dlgPush = true
          }
        })
        .catch(err => {
          console.log(err)
        })
      })
      .catch(error => {
        alert(error)
        return
      })
    },
    // function to check for valid push subscription
    checkForPushSubsciption () {
      return navigator.serviceWorker.getRegistrations()
      .then(regs => {
        if (regs.length) {
          return regs[0].pushManager.getSubscription()
        } else {
          throw Error('Service worker is not installed yet')
        }
      })
    },
    reqBrowserPromptForPush () {
      // hide the app specific custom dialog abd show the browser prompt
      this.dlgPush = false
      this.updateSubscriptionOnServer()
    },
    updateSubscriptionOnServer (subs = null) {
      if (!subs) {
        // get fresh subscription along with permission from user
        console.log('Getting fresh push subscription')
        this.askPermission()
        .then(res => {
          try {
            const subscribeOptions = {
              userVisibleOnly: true,
              applicationServerKey: this.urlB64ToUint8Array(
                'BM-8M9QH1g6T9RerpYi4rY8L3n_NG9oinXge1PahtYlrW4_fmlYZYUgem4_w6MLdZzRdxVTj9k5YFiyfKXUXHbw'
              )
            }
            navigator.serviceWorker.getRegistrations()
            .then(async regs => {
              subs = await regs[0].pushManager.subscribe(subscribeOptions)
              this.sendSubscription(subs, 'granted')
            })
          } catch (e) {
            console.log('Error subscribing for push:', e)
            this.sendSubscription(subs, 'error')
          }
        })
        .catch(err => {
          // user either skipped or blocked notification.
          this.sendSubscription(subs, err.message)
        })
      } else {
        // associate with existing subscription
        console.log('Associating existing subscription to this user')
        this.sendSubscription(subs, 'granted')
      }
    },
    askPermission () {
      return new Promise((resolve, reject) => {
        const permissionResult = Notification.requestPermission((result) => {
          resolve(result)
        })
        if (permissionResult) {
          permissionResult.then(resolve, reject)
        }
      })
      .then((permissionResult) => {
        if (permissionResult !== 'granted') {
          throw new Error(permissionResult)
        }
      })
    },
    sendSubscription (subs, subStatus) {
      if (subStatus === 'denied') {
        alert('It seems you had denied the permission earlier,\nIn Mobile: Go to settings->Apps->MyHome->Notification->Unblock\nIn Desktop: Go to browser\'s settings->Advanced->Privacy and security->Site settings->Notifications->Enable notifications for MyHome')
      }
      console.log('Sending subscription to server:' + subStatus)
      var req = {
        user_id: config.USER_ID,
        push_sub: JSON.stringify(subs),
        sub_status: subStatus
      }
      this.axios.post(config.API_URL + '/push-sub/', req)
      .catch(err => {
        console.log('Error storing subscription:', err.response.data)
      })
    },
    urlB64ToUint8Array (base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4)
      const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/')

      const rawData = atob(base64)
      const outputArray = new Uint8Array(rawData.length)

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    },
    saveTrackScreenAccess (curItem) {
      curItem.vendor_id = config.VENDOR_ID
      curItem.user_id = config.SV_USER_ID
      curItem.is_sv_user = true
      this.axios.post(config.SMARTILITY_API_URL + '/trackScreenAccess/', curItem)
      .then(response => {
      })
      .catch(err => {
        alert(err)
      })
    },
    loadRoleScreenAccessListBasedOnScreenId (curRec) {
      var qry = {
        params: {
          role_id: config.ROLE_ID,
          screen_id: curRec.screen_id
        }
      }
      this.axios.get(config.API_URL + '/getRoleScreenAccessListBasedOnScreenId/', qry)
      .then(response => {
        // getting the access for particular screen based on role id
        if (response.data.length > 0) {
          config.IS_EDITED_BY_USER = response.data[0].edit_access === 1 ? true : false
          config.IS_VIEWED_BY_USER = response.data[0].view_access === 1 ? true : false
        }
      })
      .catch(err => {
        alert(err)
      })
    }
  }
}
</script>
